import React from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import './ServicesLayout.css';

const ServicesLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isLongTerm = location.pathname === '/long-term';

  return (
    <>
      <div className="services-layout-toggle-wrapper">
        <div className="services-mode-toggle">
          <button
            className={`services-mode-btn ${!isLongTerm ? 'active' : ''}`}
            onClick={() => !isLongTerm || navigate('/services')}
          >
            <span className="material-symbols-outlined">sms</span>
            <span>Services</span>
          </button>
          <button
            className={`services-mode-btn ${isLongTerm ? 'active' : ''}`}
            onClick={() => isLongTerm || navigate('/long-term')}
          >
            <span className="material-symbols-outlined">phone_android</span>
            <span>Long Term</span>
          </button>
        </div>
      </div>
      <Outlet />
    </>
  );
};

export default ServicesLayout;
